import { render, staticRenderFns } from "./Astana.vue?vue&type=template&id=cbfad00a&"
import script from "./Astana.vue?vue&type=script&lang=js&"
export * from "./Astana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports